// Cache yönetimi 
import { 
  _normalizeParams,
  _incrementCacheVersion,
  _invalidateContentListCache,
  _invalidateContentDetailCache,
  _invalidateRelatedCaches,
  _getListTTL,
  _getDetailTTL
} from './methods/cache-management'

// İçerik yönetimi
import {
  fetchContentsList,
  fetchContentDetail,
  setContentDetail,
  getContentDetail,
  setSelectedContentId,
  clearSelectedContent,
  setSearchParams,
  setPageInfo,
  resetContentStore
} from './methods/content-management'

// Navigasyon ve asset yönetimi
import {
  resetPageState,
  setStateFromQuery,
  getQueryFromState,
  syncStateWithUrl,
  showContentDetail,
  hideContentDetail,
  updateAssetId,
  hasAssetChanged
} from './methods/navigation-management'

/**
 * Store actions
 */
export const actions = {
  // Cache yönetimi
  _normalizeParams,
  _incrementCacheVersion,
  _invalidateContentListCache,
  _invalidateContentDetailCache,
  _invalidateRelatedCaches,
  _getListTTL,
  _getDetailTTL,

  // İçerik yönetimi
  fetchContentsList,
  fetchContentDetail,
  setContentDetail,
  getContentDetail,
  setSelectedContentId,
  clearSelectedContent,
  setSearchParams,
  setPageInfo,
  resetContentStore,

  // Navigasyon ve asset yönetimi
  resetPageState,
  setStateFromQuery,
  getQueryFromState,
  syncStateWithUrl,
  showContentDetail,
  hideContentDetail,
  updateAssetId,
  hasAssetChanged
}
